<div class="container-fluid background-grey section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h2 [innerHTML]="block.data.title"></h2>
        <p [innerHTML]="block.data.bodyCopy"></p>
        <mat-accordion>
          <ng-container *ngFor="let item of block.content trackBy: trackByFn; index as i">
            <mat-expansion-panel *ngIf="item.data.title"
                                 [expanded]="i === 0 && block.data.autoExpand"
                                 (opened)="setState(i, true)"
                                 (closed)="setState(i, false)">
              <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'"
                                          [core-analytics]="{action: [getPanelState(i), item.data.title].join(':'), block}">
                <mat-panel-title [innerHTML]="item.data.title"
                                 [attr.id]="item.data.anchorId ?? 'block--' + item.uid"></mat-panel-title>
              </mat-expansion-panel-header>
              <div class="{{block.data.title}} {{block.data.visibility}}"
                   [ngClass]="{container: block.data.columnsSmall == 'full' ||  block.data.columnsNormal == 'full',
                          'col-sm-12': block.data.columnsSmall == 'full',
                          'col-md-12': block.data.columnsNormal == 'full'}"
                   [ngStyle]="{padding: block.data.padding, margin: block.data.margin }"
              >
                <core-block *ngFor="let subBlock of item.content" [block]="subBlock"
                            class="subWidget {{subBlock.data.class}}"></core-block>
              </div>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>
      </div>
    </div>

  </div>
</div>
